import { type RootState } from "~/redux/store";
import { selectLineItemsByProduct } from "~/feature/cart/cart/redux/selectors/cartSelectors";
import { createSelector } from "reselect";
import { isConfiguratorProduct } from "~/models/ProductData";
import * as PriceUtils from "~/utils/PriceUtils";
import {
  lineItemHasSurcharge,
  lineItemHasTariffSurcharge,
} from "~/feature/cart/cart/redux/selectors/productEntrySelectors";
import {
  getSurchargeValueFromTotalPrice,
  getTotalPriceForLineItem,
} from "~/feature/ProductDescriptor/v1/productDescriptorUtils";

export const selectLinearProductAmount = createSelector(
  (state: RootState) => state.products.basic,
  selectLineItemsByProduct,
  (products, lineItemsByProduct) => {
    return Object.keys(lineItemsByProduct).filter((productCode) => isConfiguratorProduct(products[productCode])).length;
  },
);
export const selectCartProductAmount = (state: RootState) => Object.values(selectLineItemsByProduct(state)).length;
export const selectCartContainsSurcharge = (state: RootState) => {
  return Object.values(state.cart.packEntriesById).some(lineItemHasSurcharge);
};

export const selectCartContainsTariffSurcharge = (state: RootState) => {
  return Object.values(state.cart.packEntriesById).some(lineItemHasTariffSurcharge);
};

export const selectCartSurcharge = (state: RootState) => {
  return PriceUtils.volatileSum(
    ...Object.values(state.cart.packEntriesById)
      .filter(lineItemHasSurcharge)
      .map((lineItem) => {
        const isSubscription = !(state.products.basic[lineItem.productCode]?.quantityVisible ?? true);
        const totalPrice = getTotalPriceForLineItem(lineItem, isSubscription);
        return getSurchargeValueFromTotalPrice(totalPrice);
      }),
  );
};
